export default __webpack_public_path__ + "static/media/img_base_rose_p.1ce1543f.jpg";